import { useContext } from 'react';
import { Grid, Tooltip } from '@mui/material';
import { ArrowLeft } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { UserDataContext } from '../../providers/userData';
import { Header } from '../../components/Header';
import { Button } from '../../components/Button';
import { LoadingScreen } from '../../components/LoadingScreen';
import { InputComponent } from '../../components/InputComponent';
import { TextComponent } from '../../components/TextComponent';
import { InputContainer, SaveButtonContainer } from './styles';
import { useTheme } from '../../providers/theme';
import { useTranslation } from 'react-i18next';

type ContractProps = {
  isLoading?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSave: (values: any) => void;
}

export function ContractPage({ isLoading, onSave }: ContractProps) {
  const navigate = useNavigate();
  const { userData } = useContext(UserDataContext);
  const { theme } = useTheme();
  const { t } = useTranslation();

  const ContractPageSchema = Yup.object().shape({
    number: Yup.string()
      .min(4, 'O valor deve conter no mínimo 4 caracteres.')
      .max(20, 'O valor deve conter no máximo 20 caracteres.')
      .required('Por favor, preencher o campo corretamente. O campo deve ter entre 4-20 caracteres.'),
    owner_id: Yup.string().email(),
  });

  return (
    <>
      {isLoading ? (
        <LoadingScreen isVisible={isLoading} />
      ) : (
        <>
          <Header />

          <Grid style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: 30, marginLeft: 100, marginTop: 30 }}>
            <Tooltip title={t('group-page-view')}>
              <ArrowLeft onClick={() => navigate('/contracts')} size={30} color={theme.colors.main} cursor='pointer' />
            </Tooltip>

            <TextComponent
              fontWeight='bold'
            >
              {t('group-page-header')}
            </TextComponent>
          </Grid>

          <Formik
            initialValues={{
              number: '',
              owner_id: userData.userEmail || ''
            }}
            validationSchema={ContractPageSchema}
            validateOnChange={true}
            validateOnMount={true}
            onSubmit={values => onSave(values)}
          >
            {({ errors, touched, handleSubmit, handleChange, values }) => (
              <>
                <form onSubmit={handleSubmit}>
                  <Grid sx={{ width: '400px', marginLeft: 12.2, marginTop: '30px', display: 'flex', flexDirection: 'column' }}>
                    <InputContainer>
                      <TextComponent
                        fontSize='14px'
                        fontWeight='bold'
                      >
                        {t('group-page-title')}
                      </TextComponent>
                      <InputComponent
                        id='number'
                        type='text'
                        value={values.number}
                        onChange={handleChange}
                        placeholder='ex: CR-333'
                      />
                      {errors.number && touched.number ? (
                        <div>
                          <span style={{ fontSize: '12px' }}>{errors.number}</span>
                        </div>
                      ) : null}
                    </InputContainer>

                    <TextComponent
                      fontSize='14px'
                      fontWeight='bold'
                    >
                      {t('group-page-manager')}
                    </TextComponent>
                    <InputComponent
                      id='owner_id'
                      type='text'
                      value={userData.userEmail}
                      readOnly
                    />
                    {errors.owner_id && touched.owner_id ? (
                      <div>
                        <span style={{ fontSize: '12px' }}>{errors.owner_id}</span>
                      </div>
                    ) : null}
                  </Grid>

                  <SaveButtonContainer>
                    <Button id='save' type='submit' color={theme.colors.main} sxhover={theme.colors.hoverMain}> {t('group-page-button')} </Button>
                  </SaveButtonContainer>
                </form>
              </>
            )}
          </Formik>
        </>
      )}
    </>
  );
}
